import { put, call } from 'redux-saga/effects';
import { fromJS, Map } from 'immutable';

// API Calls
import { fetchProductsData } from '../api/productData';

// Actions
import {
  fetchArticlePageViewSuccess,
  fetchArticlePageViewFail,
  fetchProductsDataSuccess,
  fetchProductsDataError,
  fetchDesignerDataSuccess,
  fetchDesignerDataError,
  fetchCartSuccess,
  fetchCartFail,
} from '../actions/actionCreators';

const formatData = (arrayData, key = 'id') =>
  arrayData.reduce((memory, item) => memory.merge({ [item.get(key)]: item }), Map());

export function* dataFromLitiumSaga({ payload }) {
  if (payload && payload.payload) {
    yield put(fetchCartSuccess(fromJS(payload.payload)));
  } else {
    try {
      const result = yield call(() => fetchProductsData(payload));
      if (result.products) {
        yield put(fetchProductsDataSuccess(formatData(fromJS(result.products))));
      }
      if (result.designers) {
        yield put(fetchDesignerDataSuccess(formatData(fromJS(result.designers))));
      }
      if (result.cart) {
        yield put(fetchCartSuccess(formatData(fromJS(result.cart))));
      }
      if (result.title) {
        const formatResponse = [result];
        yield put(fetchArticlePageViewSuccess(formatData(fromJS(formatResponse), 'title')));
      }
    } catch (error) {
      yield put(fetchProductsDataError(error));
      yield put(fetchDesignerDataError(error));
      yield put(fetchCartFail(error));
      yield put(fetchArticlePageViewFail(error));
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/dataFromLitiumSaga.js